import React, { useState } from 'react';
import {
  ChevronDownIcon,
  ChevronRightIcon,
  SparklesIcon,
  MagnifyingGlassIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';

interface ReasoningBlockProps {
  steps: string[];
}

export default function ReasoningBlock({ steps }: ReasoningBlockProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (!steps?.length) {
    return null;
  }

  const getStepIcon = (step: string) => {
    if (step.toLowerCase().includes('searching disgenet')) {
      return <MagnifyingGlassIcon className="reasoning-step-icon h-5 w-5 mr-2" />;
    }

    return <ChartBarIcon className="reasoning-step-icon h-5 w-5 mr-2" />;
  };

  return (
    <div className="reasoning-block">
      <button
        type="button"
        className="reasoning-header"
        onClick={() => setIsOpen(prev => !prev)}
        aria-expanded={isOpen}
      >
        <span className="reasoning-header-left row">
          <SparklesIcon className="reasoning-icon h-5 w-5 mr-2" />
          <span>Reasoning steps</span>
        </span>
        {isOpen ? (
          <ChevronDownIcon className="reasoning-icon h-4 w-4" />
        ) : (
          <ChevronRightIcon className="reasoning-icon h-4 w-4" />
        )}
      </button>

      {isOpen && (
        <div className="reasoning-content">
          <ul className="reasoning-steps-list">
            {steps.map(step => (
              <li key={step} className="reasoning-step-item row">
                {getStepIcon(step)}
                <span>{step}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
